import { all, call, put, takeLatest } from 'redux-saga/effects';
import { fetchClient } from '../utilities/fetchClient';
import ActionTypes from '../actions/actionTypes';
import {  getTransactionsSuccess, getTransactionsFailure,getTransactionItemsSuccess,getTransactionItemsFailure } from '../actions/transactionActions';
import { isMobile } from '../utilities/usersDevice';
import fileDownload from 'js-file-download';
import { transactionsDownloadFileName } from '../constants';
import Env from '../Env';
import { addToastAlert } from 'actions/toastAlertActions';
import Alert from 'constants/alert-messages';

function* getTransactions(action) {

  try {
    const header = {
      'Ocp-Apim-Subscription-Key': Env.getApimKey(),
    };

    const { isFilterClick, ...queryParams } = action.payload;

    const response = yield call(fetchClient, {
      url: 'transactions-api/v1/fleet/transactions',
      method: 'GET',
      headers: header,
      queryParams: {
        ...queryParams,
      },
      apiServer: Env.getApimBaseUrl()
    });
    yield put(getTransactionsSuccess(response, isFilterClick));

    if (response.resultMessage && isFilterClick) {
      yield put(addToastAlert(response.resultMessage, 'success'));
    }
  } catch {
    yield put(getTransactionsFailure());
  }
}

function* getTransactionsFile(action) {
  const header = {
    'Ocp-Apim-Subscription-Key': Env.getApimKey(),
  };
  try {
    yield put(addToastAlert(Alert.DOWNLOAD_TRANSACTIONS_LOADING));
    const response = yield call(fetchClient, {
      url: 'transactions-api/v1/fleet/transactions/download',
      method: 'GET',
      headers: header,
      queryParams: {
        ...action.payload
      },
      apiServer: Env.getApimBaseUrl(),
      responseType: 'blob'
    });

    if (isMobile()) {
      var reader = new FileReader();
      var blobData = new Blob([response], { type: 'application/vnd.ms-excel' });
      reader.onload = function(){
        window.location.href = reader.result;
      };
      reader.readAsDataURL(blobData);
    }
    else {
      yield call(fileDownload, response, transactionsDownloadFileName);
    }

    yield put({ type: ActionTypes.TRANSACTIONS.DOWNLOAD.SUCCESS });
    yield put(addToastAlert(Alert.DOWNLOAD_TRANSACTIONS_SUCCESS, 'success'));
  } catch {
    yield put({ type: ActionTypes.TRANSACTIONS.DOWNLOAD.FAILURE });
    yield put(addToastAlert(Alert.DOWNLOAD_TRANSACTIONS_ERROR, 'error'));
  }
}

function* getTransactionItems(action) {

  try {
    const header = {
      'Ocp-Apim-Subscription-Key': Env.getApimKey(),
    };


    const response = yield call(fetchClient, {
      url: `transactions-api/v1/fleet/transactions/${action.payload.contractAndDoc}`,
      method: 'GET',
      headers: header,
      apiServer: Env.getApimBaseUrl()
    });
    yield put(getTransactionItemsSuccess(response));
  } catch {
    yield put(getTransactionItemsFailure());
  }
}


export default function* transactionSaga() {
  yield all([
    takeLatest(ActionTypes.TRANSACTIONS.REQUEST, getTransactions),
    takeLatest(ActionTypes.TRANSACTIONITEMS.REQUEST, getTransactionItems),
    takeLatest(ActionTypes.TRANSACTIONS.DOWNLOAD.REQUEST, getTransactionsFile)
  ]);
}

